document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  const $fadeTrigger = document.querySelector(".hero-section");
  const $stickyButton = document.querySelector(".sticky-buy-button");

  if ($fadeTrigger){
    gsap.set($stickyButton, { autoAlpha: 0, y: 30 });

    ScrollTrigger.create({
        trigger: $fadeTrigger,
        start: "bottom top", // when bottom of hero hits top of viewport
        onLeave: () => {
        gsap.to($stickyButton, { 
            duration: 0.4, 
            autoAlpha: 1, 
            y: 0, 
            ease: "power2.out" 
        });
        },
        onEnterBack: () => {
        gsap.to($stickyButton, { 
            duration: 0.4, 
            autoAlpha: 0, 
            y: 30, 
            ease: "power2.in" 
        });
        }
    });
  } else {
    $stickyButton.style.opacity = 1;
  }

 
});
